<template>
  <div class="flex items-center">
    <vx-tooltip v-for="({ component, disabled, name }, i) in steps"
                :key="i"
                class="w-16 h-full flex items-center justify-center"
                :class="[
                  disabled ? 'cursor-not-allowed text-gray': 'cursor-pointer',
                  { 'hover:bg-primary-light': !disabled }
                ]"
                position="top"
                text="No more history left"
                :enabled="disabled && name.toLowerCase().includes('conversation')"
                @click.native="$emit('step', { disabled, name })"
    >
      <component :is="component"
                 :key="i"
                 class="h-4"/>
    </vx-tooltip>
  </div>
</template>

<script>
import RewindBackIcon from '../../../../assets/images/icons/RewindBackIcon.vue'
import StepBackIcon from '../../../../assets/images/icons/StepBackIcon.vue'
import StepForwardIcon from '../../../../assets/images/icons/StepForwardIcon.vue'
import RewindForwardIcon from '../../../../assets/images/icons/RewindForwardIcon.vue'

export default {
  name: 'ConversationNavigationButtonsBlock',

  components: {
    RewindBackIcon,
    RewindForwardIcon,
    StepBackIcon,
    StepForwardIcon
  },

  props: {
    steps: {
      type: Array,
      required: true
    }
  }
}
</script>
